import { configureStore } from '@reduxjs/toolkit';
import { appDataReducer } from './appDataStore';
import { userDataReducer } from './userDataStore';
import { gitlabAdminReducer } from './gitlabAdminStore';

// L'auth n'est plus un reducer Redux : store observable "maison" persisté dans
// localStorage (voir store/authStore.ts), aligné sur SITES_WEB/app_mystic.
export const store = configureStore({
  reducer: {
    appData: appDataReducer,
    userData: userDataReducer,
    gitlabAdmin: gitlabAdminReducer
  },
  devTools: true
});

// Exposer le store globalement pour Redux DevTools
if (typeof window !== 'undefined') {
  (window as any).__REDUX_STORE__ = store;
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
